import { render, staticRenderFns } from "./FilesSetting.vue?vue&type=template&id=7ca71d47"
import script from "./FilesSetting.vue?vue&type=script&lang=js"
export * from "./FilesSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports